<dgx-modal
  *ngIf="vm"
  [useDefaultForm]="false"
  [useDefaultSubmitButton]="false"
  (dismiss)="dismiss()"
  [canCancel]="true"
>
  <ng-container class="modal-header">
    <span>
      {{ vm.modalHeaderText }}
    </span>
  </ng-container>
  <ng-container class="modal-body">
    <df-local-notification
      *ngIf="
        (submitAttempted || ruleIsInitiallyInvalid) && vm.ruleIsInvalid(vm.form)
      "
      [type]="NotificationType.warning"
      [text]="vm.i18n.BusinessRules_RuleError_Description"
      size="small"
      class="guts-m-t-1 block"
    ></df-local-notification>
    <form
      role="form"
      [formGroup]="vm.form"
      #formElement
      class="form-wrap guts-p-t-1 guts-p-h-1"
      (ngSubmit)="submit()"
    >
      <div class="par--small guts-m-b-1">
        {{ vm.i18n.Core_AllFieldsRequired }}
      </div>
      <div class="guts-m-b-2">
        <label for="ruleName">{{ vm.ruleNameLabel }}</label>
        <dgx-character-limit-input
          [limit]="255"
          [text]="vm.form.get('ruleName').value"
        >
          <input
            dgxAutofocus
            type="text"
            id="ruleName"
            formControlName="ruleName"
            data-dgat="business-rule-add-edit-modal-1b5"
            [placeholder]="vm.ruleNamePlaceholder"
            maxLength="255"
            pattern=".*\S.*"
          />
        </dgx-character-limit-input>
        <dgx-validate-field
          *ngIf="
            vm.form.get('ruleName').invalid &&
            (submitAttempted || ruleIsInitiallyInvalid)
          "
          [message]="
            vm.form.get('ruleName').hasError('ruleNameUnavailable')
              ? vm.i18n.BusinessRules_Error_DuplicateRuleName
              : vm.i18n.Core_FieldRequired
          "
        ></dgx-validate-field>
      </div>
      <div class="guts-m-b-1 par par--small font-semibold" *ngIf="vm.isSegment">
        {{ vm.i18n.BusinessRules_AttributeInstructions }}
      </div>
      <ng-container *ngIf="vm.attributes">
        <ng-container
          *ngFor="
            let predicate of vm.form.get('predicates')['controls'];
            let i = index
          "
          data-dgat="business-rule-add-edit-modal-8e4"
        >
          <ng-container [formGroup]="predicate">
            <div class="business-rule-form__row guts-m-b-1">
              <div
                class="l_w5 guts-m-r-1 business-rule-form__col--centered"
                *ngIf="!vm.isSegment"
              >
                <label>{{ vm.predicateLabel(i) }}</label>
              </div>
              <div class="l_w30 guts-m-r-1">
                <label [for]="'attributeName-' + i">{{
                  vm.i18n.BusinessRules_Condition
                }}</label>

                <dgx-combobox
                  [id]="'attributeName-' + i"
                  #predicateNameField
                  [getOptions]="
                    getOptions(
                      vm.attributeOptions,
                      i,
                      vm.form.get('predicates')['controls']
                    )
                  "
                  [labelKey]="'title'"
                  dgatInput="business-rule-add-edit-modal-278"
                  [selectedOption]="predicate.value.fieldDisplayName"
                  (selection)="vm.setFieldName($event, predicate)"
                  [placeholder]="vm.i18n.BusinessRules_AttributeName"
                  [hasNoResultsText]="vm.i18n.Core_NoResults"
                ></dgx-combobox>
                <dgx-validate-field
                  *ngIf="
                    predicate.get('fieldName').invalid &&
                    (submitAttempted || ruleIsInitiallyInvalid)
                  "
                  [message]="vm.i18n.Core_FieldRequired"
                ></dgx-validate-field>
              </div>
              <div class="l_w25 guts-m-r-1">
                <ng-container *ngIf="!vm.shouldShowOperatorAndValue(predicate)">
                  <input
                    [attr.id]="'operatorLabel-' + i"
                    type="text"
                    formControlName="comparisonOperator"
                    data-dgat="business-rule-upsert-modal-64f"
                    hidden="true"
                  />
                </ng-container>
                <ng-container *ngIf="vm.shouldShowOperatorAndValue(predicate)">
                  <label [attr.id]="'operatorLabel-' + i">{{
                    vm.i18n.BusinessRules_Operator
                  }}</label>
                  <dgx-select
                    [ariaLabelledby]="'operatorLabel-' + i"
                    class="full-width"
                    [isRequired]="true"
                    [isDisabled]="!predicate.value.fieldName"
                    [options]="
                      vm.getTypesFromAttribute(
                        vm.attributes,
                        predicate.value.fieldName,
                        predicate.value.comparisonOperator
                      )
                    "
                    labelKey="name"
                    trackBy="value"
                    dgatInput="business-rule-upsert-modal-64f"
                    (selection)="vm.setComparisonOperator($event, predicate)"
                    [selectedItem]="predicate.value.comparisonOperator"
                  >
                  </dgx-select>
                </ng-container>
              </div>
              <div class="l_w40 guts-m-r-1">
                <ng-container *ngIf="!vm.shouldShowOperatorAndValue(predicate)">
                  <input
                    [attr.id]="'attributeValue-' + i"
                    type="text"
                    formControlName="comparisonValue"
                    data-dgat="business-rule-add-edit-modal-a1d"
                    hidden="true"
                  />
                </ng-container>
                <ng-container *ngIf="vm.shouldShowOperatorAndValue(predicate)">
                  <label [attr.for]="'attributeValue-' + i"
                    >{{ vm.i18n.BusinessRules_AttributeValue }}
                  </label>

                  <ng-container
                    [ngSwitch]="
                      vm.getAttributeType(
                        vm.attributes,
                        predicate.value.fieldName,
                        predicate.value.comparisonOperator
                      )
                    "
                  >
                    <div *ngSwitchCase="AttributeDataType.String">
                      <dgx-character-limit-input
                        [limit]="200"
                        [text]="predicate.get('comparisonValue').value"
                      >
                        <input
                          [attr.id]="'attributeValue-' + i"
                          type="text"
                          formControlName="comparisonValue"
                          data-dgat="business-rule-add-edit-modal-a1d"
                          [placeholder]="vm.i18n.BusinessRules_AttributeValue"
                          title="{{ vm.i18n.BusinessRules_AttributeValue }}"
                          maxLength="200"
                        />
                      </dgx-character-limit-input>
                    </div>
                    <div *ngSwitchCase="AttributeDataType.Number">
                      <div class="business-rule-form__row">
                        <div class="l_w100">
                          <input
                            [attr.id]="'attributeValue-' + i"
                            type="number"
                            formControlName="comparisonValue"
                            data-dgat="business-rule-add-edit-modal-a1d"
                            title="{{ vm.i18n.BusinessRules_AttributeValue }}"
                            [placeholder]="vm.i18n.BusinessRules_AttributeValue"
                            maxLength="200"
                            [attr.min]="
                              vm.getAttributeValueMin(
                                vm.attributes,
                                predicate.value.fieldName,
                                predicate.value.comparisonOperator
                              )
                            "
                          />
                        </div>
                        <div
                          class="
                            l_w40
                            guts-p-l-1
                            business-rule-form__folowing-label
                            par--small
                          "
                          *ngIf="
                            vm.getFollowingLabel(
                              vm.attributes,
                              predicate.value.fieldName,
                              predicate.value.comparisonOperator
                            ) as trailingLabel
                          "
                        >
                          {{ trailingLabel }}
                        </div>
                      </div>
                    </div>
                    <div *ngSwitchCase="AttributeDataType.DateTime">
                      <dgx-date-picker
                        [date]="predicate.get('comparisonValue').value"
                        [isMinDateToday]="false"
                        [placeholder]="'Select a date'"
                        (dateSelect)="vm.setPredicateDate($event, predicate)"
                      >
                      </dgx-date-picker>
                    </div>
                    <div *ngSwitchCase="AttributeDataType.Bool">
                      <dgx-select
                        [id]="'attributeValue-' + i"
                        formControlName="comparisonValue"
                        class="full-width"
                        [options]="booleanOptions"
                        labelKey="name"
                        trackBy="value"
                        (selection)="vm.setComparisonValue($event, predicate)"
                        [selectedItem]="predicate.value.comparisonValue"
                        [placeholder]="vm.i18n.BusinessRules_Value"
                      ></dgx-select>
                    </div>
                  </ng-container>
                  <dgx-validate-field
                    *ngIf="
                      predicate.get('comparisonValue').invalid &&
                      (submitAttempted || ruleIsInitiallyInvalid)
                    "
                    [message]="vm.i18n.Core_FieldRequired"
                  ></dgx-validate-field>
                </ng-container>
              </div>
              <div class="business-rule-form__col--centered">
                <button
                  type="button"
                  class="color-ebony-a61"
                  (click)="vm.removePredicate(i)"
                  [attr.aria-label]="vm.i18n.BusinessRules_RemoveCondition"
                  data-dgat="business-rule-add-edit-modal-5ef"
                  title="{{ vm.i18n.BusinessRules_RemoveRule }}"
                  *ngIf="vm.form.get('predicates')['controls'].length > 1"
                >
                  <df-icon icon="cross-circle"></df-icon>
                </button>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
      <div *ngIf="vm.canAddMorePredicates()">
        <div *ngIf="!vm.isSegment" class="ib l_w5"></div>
        <button
          df-button
          dfButtonType="clear"
          df-button-small
          (click)="vm.addPredicate()"
          [class.guts-p-l-half]="!vm.isSegment"
          class="color-blue"
          data-dgat="business-rule-add-edit-modal-ec8"
        >
          <div class="l_flexbar gap-full-half">
            <df-icon icon="plus"></df-icon>
            <div>{{ vm.addPredicateLabel }}</div>
          </div>
        </button>
      </div>
      <div *ngIf="!vm.isSegment" class="guts-p-v-2 divider"></div>
      <ng-container *ngIf="vm.updateTypeOptions | async as updateTypeOptions">
        <ng-container *ngIf="vm.form.get('outcomes')">
          <ng-container
            *ngFor="
              let outcome of vm.form.get('outcomes')['controls'];
              let i = index
            "
            data-dgat="business-rule-add-edit-modal-651"
          >
            <ng-container [formGroup]="outcome">
              <div class="business-rule-form__row guts-m-b-1">
                <div class="l_w5 guts-m-r-1 business-rule-form__col--centered">
                  <label>{{ vm.i18n.BusinessRules_Then }}</label>
                </div>
                <div class="l_w40 guts-m-r-1">
                  <div>
                    <label [attr.id]="'outcomeTypeLabel-' + i">{{
                      vm.i18n.BusinessRules_ActionType
                    }}</label>
                    <dgx-select
                      [ariaLabelledby]="'outcomeTypeLabel-' + i"
                      #outcomeDropdown
                      class="full-width"
                      [id]="'updateTypeResource-' + i"
                      [options]="updateTypeOptions"
                      labelKey="name"
                      trackBy="value"
                      (selection)="vm.setUpdateType($event, outcome)"
                      [selectedItem]="outcome.value.updateTypeResourceId"
                      [placeholder]="
                        'OrgManage_Opportunities_TypePlaceholder' | translate
                      "
                      [isDisabled]="vm.isDeleteRule()"
                      dgatInput="business-rule-upsert-modal-69a"
                    >
                    </dgx-select>
                  </div>
                </div>
                <div class="l_w55 guts-m-r-1">
                  <ng-container [ngSwitch]="outcome.value.updateTypeResourceId">
                    <label [attr.for]="'updateValue-' + i">{{
                      vm.i18n.BusinessRules_Value
                    }}</label>
                    <ng-container *ngSwitchCase="'AddToGroup'">
                      <dgx-group-search-field
                        [orgId]="this.orgId"
                        [selectedName]="outcome.get('displayName').value"
                        (onSelection)="vm.setOutcomeValue($event, outcome)"
                        (onRemove)="vm.removeOutcomeValue(outcome)"
                        [customFormControl]="outcome.get('updateValue')"
                        [placeholderText]="
                          'OrgGroupsCtrl_SearchforGroup' | translate
                        "
                        [notFoundText]="
                          'OrgReportingCtrl_NoMatchingGroups' | translate
                        "
                      ></dgx-group-search-field>
                    </ng-container>
                    <ng-container *ngSwitchCase="'AddToPathway'">
                      <dgx-pathway-search-field
                        [orgId]="this.orgId"
                        [selectedName]="outcome.get('displayName').value"
                        (onSelection)="vm.setOutcomeValue($event, outcome)"
                        (onRemove)="vm.removeOutcomeValue(outcome)"
                        [customFormControl]="outcome.get('updateValue')"
                        [placeholderText]="'Core_SearchForPathway' | translate"
                        [notFoundText]="'Core_NoResults' | translate"
                      ></dgx-pathway-search-field>
                    </ng-container>
                    <ng-container *ngSwitchCase="'AddProviderLicense'">
                      <dgx-provider-license-search-field
                        [orgId]="this.orgId"
                        [selectedName]="outcome.get('displayName').value"
                        (onSelection)="vm.setOutcomeValue($event, outcome)"
                        (onRemove)="vm.removeOutcomeValue(outcome)"
                        [customFormControl]="outcome.get('updateValue')"
                        [placeholderText]="
                          'BusinessRules_SearchForProviderLicense' | translate
                        "
                        [notFoundText]="'Core_NoResults' | translate"
                      ></dgx-provider-license-search-field>
                    </ng-container>
                    <ng-container *ngSwitchCase="'AddRole'">
                      <dgx-role-search-field
                        [orgId]="this.orgId"
                        [selectedName]="outcome.get('displayName').value"
                        (onSelection)="vm.setOutcomeValue($event, outcome)"
                        (onRemove)="vm.removeOutcomeValue(outcome)"
                        [customFormControl]="outcome.get('updateValue')"
                        [placeholderText]="
                          'BusinessRules_SearchForRole' | translate
                        "
                        [notFoundText]="'Core_NoResults' | translate"
                      ></dgx-role-search-field>
                    </ng-container>
                    <ng-container *ngSwitchCase="'AddSkillPlan'">
                      <dgx-skill-plan-search-field
                        [orgId]="this.orgId"
                        [selectedName]="outcome.get('displayName').value"
                        (onSelection)="vm.setOutcomeValue($event, outcome)"
                        (onRemove)="vm.removeOutcomeValue(outcome)"
                        [customFormControl]="outcome.get('updateValue')"
                        [placeholderText]="
                          'BusinessRules_SearchForSkillPlan' | translate
                        "
                        [notFoundText]="'Core_NoResults' | translate"
                      ></dgx-skill-plan-search-field>
                    </ng-container>
                    <ng-container *ngSwitchCase="'AddSkill'">
                      <dgx-skill-search-field
                        [orgId]="this.orgId"
                        [selectedName]="outcome.get('displayName').value"
                        (onSelection)="vm.setOutcomeValue($event, outcome)"
                        (onRemove)="vm.removeOutcomeValue(outcome)"
                        [customFormControl]="outcome.get('updateValue')"
                        [placeholderText]="
                          'BusinessRules_SearchForSkill' | translate
                        "
                        [notFoundText]="'Core_NoResults' | translate"
                        [freeTextDesc]="
                          'BusinessRules_NewItem_Format_AddNewSkill'
                        "
                      ></dgx-skill-search-field>
                    </ng-container>
                    <ng-container *ngSwitchCase="'SetProfilePrivacy'">
                      <dgx-profile-privacy-field
                        [selectedValue]="outcome.get('displayName').value"
                        (onSelection)="vm.setOutcomeValue($event, outcome)"
                        [customFormControl]="outcome.get('updateValue')"
                        [placeholderText]="
                          'BusinessRules_SetProfilePrivacy' | translate
                        "
                      ></dgx-profile-privacy-field>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                      <input
                        type="text"
                        [id]="'updateValue-' + i"
                        title="{{ vm.i18n.BusinessRules_Value }}"
                        data-dgat="business-rule-add-edit-modal-07d"
                        [placeholder]="vm.i18n.BusinessRules_Value"
                        [disabled]="true"
                      />
                    </ng-container>

                    <dgx-validate-field
                      *ngIf="
                        outcome.get('updateValue').invalid &&
                        (submitAttempted || ruleIsInitiallyInvalid)
                      "
                      [message]="vm.i18n.Core_FieldRequired"
                    ></dgx-validate-field>
                  </ng-container>
                </div>
                <div class="business-rule-form__col--centered">
                  <button
                    type="button"
                    class="color-ebony-a61"
                    (click)="vm.removeOutcome(i)"
                    [attr.aria-label]="vm.i18n.BusinessRules_RemoveAction"
                    data-dgat="business-rule-add-edit-modal-5ef"
                    title="{{ vm.i18n.BusinessRules_RemoveAction }}"
                    *ngIf="vm.form.get('outcomes')['controls'].length > 1"
                  >
                    <df-icon icon="cross-circle"></df-icon>
                  </button>
                </div>
              </div>
            </ng-container>
          </ng-container>
          <div>
            <div class="ib l_w5"></div>
            <button
              df-button
              dfButtonType="clear"
              df-button-small
              (click)="vm.addOutcome()"
              class="color-blue guts-m-b-2 guts-p-l-half"
              data-dgat="business-rule-add-edit-modal-da8"
              *ngIf="!vm.isDeleteRule()"
            >
              <div class="l_flexbar gap-full-half">
                <df-icon icon="plus"></df-icon>
                <div>{{ vm.i18n.BusinessRules_AddAction }}</div>
              </div>
            </button>
          </div>
        </ng-container>
      </ng-container>
      <df-local-notification
        *ngIf="
          vm.form.get('outcomes') &&
          vm.ruleHasPrivacyWarning(vm.form.get('outcomes')['controls'])
        "
        [type]="NotificationType.warning"
        [text]="vm.i18n.BusinessRules_PrivacyOutcomeWarning"
        size="small"
        class="guts-m-t-1 block"
      ></df-local-notification>
    </form>
  </ng-container>
  <ng-container class="modal-footer">
    <button
      type="submit"
      df-button
      dfButtonType="primary"
      (click)="submit()"
      data-dgat="business-rule-add-edit-modal-d01"
      [disabled]="isSubmitDisabled"
    >
      <df-spinner-button [isSpinning]="isLoading">
        {{ vm.i18n.Core_Save }}
      </df-spinner-button>
    </button>
  </ng-container>
</dgx-modal>
